import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useLayoutStyles } from '../layouts/layout-context';
import type { Sx } from '../layouts/types';
import { AccentText } from './accent-text';

interface SectionHeadProps {
  kicker: string;
  icon: ReactNode;
  title: string;
  lede?: string;
  /** A layout slot that replaces the shared head, for a section that spaces it differently. */
  sx?: Sx;
}

export const SectionHead = ({ kicker, icon, title, lede, sx }: SectionHeadProps) => {
  const s = useLayoutStyles('shared');

  return (
    <Box sx={sx ?? s.sectionHead}>
      <Box sx={s.kicker}>
        {icon}
        {kicker}
      </Box>
      <Typography component="h2" sx={s.sectionTitle}>
        <AccentText text={title} surface="light" />
      </Typography>
      {lede ? (
        <Typography component="p" sx={s.sectionLede}>
          {lede}
        </Typography>
      ) : null}
    </Box>
  );
};
